/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FccModelEditorViewModel } from '../models/fcc-model-editor-view-model';
import { FccModelQueryReponseViewModel } from '../models/fcc-model-query-reponse-view-model';
import { FccModel } from '../models/fcc-model';
@Injectable({
  providedIn: 'root',
})
class FCCsMaintenanceService extends __BaseService {
  static readonly CreatePath = '/view/jpats/maintenance/fccs/Create';
  static readonly GetByKeyPath = '/view/jpats/maintenance/fccs/{fccKey}';
  static readonly QueryPath = '/view/jpats/maintenance/fccs/Query';
  static readonly SavePath = '/view/jpats/maintenance/fccs/Save';
  static readonly GetPatientCountPath = '/view/jpats/maintenance/fccs/{fccKey}/PatientCount';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  CreateResponse(): __Observable<__StrictHttpResponse<FccModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/maintenance/fccs/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FccModelEditorViewModel>;
      })
    );
  }
  /**
   * @return Success
   */
  Create(): __Observable<FccModelEditorViewModel> {
    return this.CreateResponse().pipe(
      __map(_r => _r.body as FccModelEditorViewModel)
    );
  }

  /**
   * @param fccKey undefined
   * @return Success
   */
  GetByKeyResponse(fccKey: string): __Observable<__StrictHttpResponse<FccModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/maintenance/fccs/${fccKey}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FccModelEditorViewModel>;
      })
    );
  }
  /**
   * @param fccKey undefined
   * @return Success
   */
  GetByKey(fccKey: string): __Observable<FccModelEditorViewModel> {
    return this.GetByKeyResponse(fccKey).pipe(
      __map(_r => _r.body as FccModelEditorViewModel)
    );
  }

  /**
   * @param params The `FCCsMaintenanceService.QueryParams` containing the following parameters:
   *
   * - `Take`:
   *
   * - `State.MetadataKey`:
   *
   * - `State.Key`:
   *
   * - `State.Description`:
   *
   * - `State.Active`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `MedicalCenter`:
   *
   * - `Longitude`:
   *
   * - `Lattitude`:
   *
   * - `IncludeInactive`:
   *
   * - `ForExport`:
   *
   * - `FCCName`:
   *
   * - `EmergencyManager`:
   *
   * - `Director`:
   *
   * @return Success
   */
  QueryResponse(params: FCCsMaintenanceService.QueryParams): __Observable<__StrictHttpResponse<FccModelQueryReponseViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Take != null) __params = __params.set('Take', params.Take.toString());
    if (params.StateMetadataKey != null) __params = __params.set('State.MetadataKey', params.StateMetadataKey.toString());
    if (params.StateKey != null) __params = __params.set('State.Key', params.StateKey.toString());
    if (params.StateDescription != null) __params = __params.set('State.Description', params.StateDescription.toString());
    if (params.StateActive != null) __params = __params.set('State.Active', params.StateActive.toString());
    if (params.SortOrder != null) __params = __params.set('SortOrder', params.SortOrder.toString());
    if (params.SortBy != null) __params = __params.set('SortBy', params.SortBy.toString());
    if (params.Skip != null) __params = __params.set('Skip', params.Skip.toString());
    if (params.PageSize != null) __params = __params.set('PageSize', params.PageSize.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.MedicalCenter != null) __params = __params.set('MedicalCenter', params.MedicalCenter.toString());
    if (params.Longitude != null) __params = __params.set('Longitude', params.Longitude.toString());
    if (params.Lattitude != null) __params = __params.set('Lattitude', params.Lattitude.toString());
    if (params.IncludeInactive != null) __params = __params.set('IncludeInactive', params.IncludeInactive.toString());
    if (params.ForExport != null) __params = __params.set('ForExport', params.ForExport.toString());
    if (params.FCCName != null) __params = __params.set('FCCName', params.FCCName.toString());
    if (params.EmergencyManager != null) __params = __params.set('EmergencyManager', params.EmergencyManager.toString());
    if (params.Director != null) __params = __params.set('Director', params.Director.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/maintenance/fccs/Query`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FccModelQueryReponseViewModel>;
      })
    );
  }
  /**
   * @param params The `FCCsMaintenanceService.QueryParams` containing the following parameters:
   *
   * - `Take`:
   *
   * - `State.MetadataKey`:
   *
   * - `State.Key`:
   *
   * - `State.Description`:
   *
   * - `State.Active`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `MedicalCenter`:
   *
   * - `Longitude`:
   *
   * - `Lattitude`:
   *
   * - `IncludeInactive`:
   *
   * - `ForExport`:
   *
   * - `FCCName`:
   *
   * - `EmergencyManager`:
   *
   * - `Director`:
   *
   * @return Success
   */
  Query(params: FCCsMaintenanceService.QueryParams): __Observable<FccModelQueryReponseViewModel> {
    return this.QueryResponse(params).pipe(
      __map(_r => _r.body as FccModelQueryReponseViewModel)
    );
  }

  /**
   * @param fccModel undefined
   * @return Success
   */
  SaveResponse(fccModel?: FccModel): __Observable<__StrictHttpResponse<FccModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = fccModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/maintenance/fccs/Save`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FccModelEditorViewModel>;
      })
    );
  }
  /**
   * @param fccModel undefined
   * @return Success
   */
  Save(fccModel?: FccModel): __Observable<FccModelEditorViewModel> {
    return this.SaveResponse(fccModel).pipe(
      __map(_r => _r.body as FccModelEditorViewModel)
    );
  }

  /**
   * @param fccKey undefined
   * @return Success
   */
  GetPatientCountResponse(fccKey: string): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/maintenance/fccs/${fccKey}/PatientCount`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: parseFloat((_r as HttpResponse<any>).body as string) }) as __StrictHttpResponse<number>
      })
    );
  }
  /**
   * @param fccKey undefined
   * @return Success
   */
  GetPatientCount(fccKey: string): __Observable<number> {
    return this.GetPatientCountResponse(fccKey).pipe(
      __map(_r => _r.body as number)
    );
  }
}

module FCCsMaintenanceService {

  /**
   * Parameters for Query
   */
  export interface QueryParams {
    Take?: number;
    StateMetadataKey?: string;
    StateKey?: string;
    StateDescription?: string;
    StateActive?: boolean;
    SortOrder?: number;
    SortBy?: string;
    Skip?: number;
    PageSize?: number;
    Page?: number;
    MedicalCenter?: string;
    Longitude?: string;
    Lattitude?: string;
    IncludeInactive?: boolean;
    ForExport?: boolean;
    FCCName?: string;
    EmergencyManager?: string;
    Director?: string;
  }
}

export { FCCsMaintenanceService }
